const MAX_ZOOM = 16;
const MIN_ZOOM = 5;

export const searchPageHandlerComponent = {
	templateUrl: 'search-page-handler-template.html',
	controller: class searchPageHandlerComponent {
		constructor(NgMap, $rootScope, $mdDialog, $timeout, CommonConstants, notificationService) {
			'ngInject';
			this.ngMap = NgMap;
			this.$rootScope = $rootScope;
			this.$mdDialog = $mdDialog;
			this.$timeout = $timeout;
			this.markers = [];
			this.popupMarkers = [];
			this.constants = CommonConstants;
			this.notificationService = notificationService;
		}

		$onInit() {
			if (!this.initialized) {
				this.initialized = true;
				if (window.location.hash) {
					let hash = window.location.hash;
					let arrHash = hash.split('/');
					this.searchText = decodeURI(arrHash[1].substr(arrHash[1].indexOf('=') + 1));
					this.view = arrHash.length > 2 ? arrHash[2].substr(arrHash[2].indexOf('=') + 1) : 'list';
				} else {
					this.view = 'list';
				}
				if (window.localStorage.getItem('selectedItem')) {
					this.selectedItem = JSON.parse(window.localStorage.getItem('selectedItem'));
					window.localStorage.removeItem('selectedItem');
					this.$timeout(() => {
						this.openModal(this.selectedItem);
						// popup map!!
						this.initMap();
					});
				}
			}
		}

		selectFromList($event) {
			this.selectedItem = $event.listElement;
			this.openModal(this.selectedItem);
			// popup map!!
			this.initMap();
		}

		/** popup map */

		initMap() {
			let item = angular.copy(this.selectedItem);
			let itemType = item.type;
			let id = '';
			if (itemType == 'office') {
				id = 'oc-result-office-map';
			} else if (itemType == 'person') {
				id = 'oc-result-consultant-map';
			}
			let vm = this;
			this.ngMap.getMap(id).then((map) => {
				vm.clearMarkers(vm.popupMarkers);
				vm.popupMarkers = [];
				let contentString = vm.getContentString(item);
				let position = itemType == 'office' ?
					new window.google.maps.LatLng(item.lat, item.lng) :
					new window.google.maps.LatLng(item.office.lat, item.office.lng);
				vm.$rootScope.destination = itemType == 'office' ?
					item.lat + ', ' + item.lng :
					item.office.lat + ', ' + item.office.lng;
				let marker = this.createMarker(map, position);
				vm.popupMarkers = [marker];
				let infoWindow = vm.createInfoWindow(contentString);
				vm.addClickEventToMarker(marker, infoWindow, map);
				map.setCenter(position);
				vm.$timeout(() => {
					window.google.maps.event.addListenerOnce(map, 'idle', function () {
						window.google.maps.event.trigger(map, 'resize');
					});
				});
			});
		}

		getContentString(item) {
			return '<div>' + item.name + '</div>';
		}

		createMarker(map, position) {
			return new window.google.maps.Marker({
				position: position,
				map: map,
				icon: '/static/assets/img/pin.svg'
			});
		}

		createInfoWindow(contentString) {
			return new window.google.maps.InfoWindow({
				content: contentString,
				maxWidth: 400
			});
		}

		addClickEventToMarker(marker, infoWindow, map, lat, lng, $scope, item) {
			marker.addListener('click', function () {
				if ($scope && item) {
					$scope.$timeout(() => {
						$scope.selectedItem = item;
						$scope.openModal($scope.selectedItem);
						$scope.initMap();
					}, 300);
				}
				if (infoWindow && map) {
					infoWindow.open(map, marker);
				}
			});
		}

		setDirection(type) {
			if (type == 'office') {
				window.open('https://www.google.com/maps/dir/?api=1&destination=' + this.selectedItem.lat + ',' + this.selectedItem.lng, '_blank');
			} else {
				window.open('https://www.google.com/maps/dir/?api=1&destination=' + this.selectedItem.office.lat + ',' + this.selectedItem.office.lng, '_blank');
			}
		}

		clearMarkers(arr) {
			if (arr.length) {
				for (let i = 0; i < arr.length; i++) {
					arr[i].setMap(null);
				}
			}
		}

		openModal(element) {
			this.$mdDialog.show({
				templateUrl: element.type == 'person' ? 'oc-result-consultant-popup.html' : 'oc-result-office-popup.html',
				clickOutsideToClose: true,
				controller:()=>this,
				controllerAs: '$ctrl',
				onShowing: () => {
					this.ngMap.getMap().then((map) => {
						// console.log(map);
						google.maps.event.trigger(map, 'resize');
					});
				}
			});
		}

		close() {
			this.$mdDialog.hide();
		}

		/**
		 * Térképes nézet
		 */

		successSearchByMap($event) {
			this.hitsList = $event.resultListByMap;
			this.notificationService.showInfo({
				message: 'noOcResult'
			});

			this.view = 'map';
			this.initMapViewMap();
		}

		initMapViewMap() {
			let items = angular.copy(this.hitsList);
			let vm = this;
			this.ngMap.getMap('office-search-map').then((map) => {
				vm.clearMarkers(vm.markers);
				vm.markers = [];
				let mapBounds = new window.google.maps.LatLngBounds();
				for (let i = 0; i < items.length; i++) {
					let item = items[i];
					let lat = item.lat;
					let lng = item.lng;
					// let contentString = vm.getContentString(item);
					let position = new window.google.maps.LatLng(lat, lng);
					let marker = vm.createMarker(map, position);
					vm.markers.push(marker);
					vm.addClickEventToMarker(marker, null, map, lat, lng, this, item);
					mapBounds.extend(position);
				}
				window.google.maps.event.trigger(map, 'resize');
				map.fitBounds(mapBounds);
				map.setCenter(mapBounds.getCenter());
			});
		}

		backToList() {
			window.location.href = '/iroda-kereso';
		}
	},
	transclude: true,
	controllerAs: 'irta'
};
